export default __webpack_public_path__ + "static/media/06.18bc31cb.jpg";